module.exports = __webpack_public_path__ + "img/kv@2x.50648cfb.png";